import styled from "styled-components";

const ReadOnlyName = styled.div`
  font-weight: 500;
`;

export default ReadOnlyName;
